/**
 * Values for a debounced save. While the form is shown they come from validating it, so
 * required fields are checked with the latest input. Once the component has unmounted its
 * fields are no longer registered and validation would resolve with an empty object, so the
 * snapshot taken when the save was scheduled is used instead.
 */
export const valuesForScheduledSave = <T>(
    mounted: boolean,
    snapshot: T | undefined,
    validate: () => Promise<T>
): Promise<T> => (mounted || snapshot === undefined ? validate() : Promise.resolve(snapshot));
